/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TheOutageCallout.vue?vue&type=template&id=4ba92486&scoped=true"
import script from "./TheOutageCallout.ts?vue&type=script&lang=ts&external"
export * from "./TheOutageCallout.ts?vue&type=script&lang=ts&external"
import style0 from "./TheOutageCallout.vue?vue&type=style&index=0&id=4ba92486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba92486",
  null
  
)

export default component.exports